module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'user-address'
      }
    }
  }, [_vm._v("Piegādes adrese")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Rediģēt adresi")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    class: {
      loading: _vm.showLoading
    }
  }, [(_vm.legalAddressError) ? _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "warning circle icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "ui form"
  }, [_c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Rediģēt adresi")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "ui negative icon message"
  }, [_c('i', {
    staticClass: "warning circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Lūdzu aizpildi visus laukus:\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.error), function(item) {
    return _c('li', [_vm._v(_vm._s(item[0]))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressItem.is_legal_address),
      expression: "addressItem.is_legal_address"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.address.is_legal_address == 1,
      "value": "1",
      "number": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.addressItem.is_legal_address) ? _vm._i(_vm.addressItem.is_legal_address, "1") > -1 : (_vm.addressItem.is_legal_address)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.addressItem.is_legal_address,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.addressItem, "is_legal_address", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.addressItem, "is_legal_address", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.addressItem, "is_legal_address", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newsletter"
    }
  }, [_vm._v("Juridiskā adrese")])])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Pilsēta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.city),
      expression: "address.city"
    }],
    staticClass: "ui fluid dropdown",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.address, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.city), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Reģions")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.region),
      expression: "address.region"
    }],
    staticClass: "ui fluid dropdown",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.address, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.filteredRegion), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "three fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Iela")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.street),
      expression: "address.street"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Iela",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "street", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Mājas nr. / nosaukums")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.house_no),
      expression: "address.house_no"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Mājas nr. / nosaukums",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.address.house_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "house_no", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Dzīvokļa nr.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.flat_no),
      expression: "address.flat_no"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Dzīvokļa nr.",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.address.flat_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "flat_no", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Tālrunis kurjeram")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressItem.phone),
      expression: "addressItem.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Norādiet tālruni kurjeram"
    },
    domProps: {
      "value": (_vm.addressItem.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addressItem, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Piezīmes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressItem.notes),
      expression: "addressItem.notes"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Piemēram, durvju kods"
    },
    domProps: {
      "value": (_vm.addressItem.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addressItem, "notes", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "ui right floated grey icon button",
    on: {
      "click": function($event) {
        return _vm.initDeleteAddress(_vm.address)
      }
    }
  }, [_c('i', {
    staticClass: "right trash icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui right floated buttons",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'user-address'
        })
      }
    }
  }, [_vm._v("Atpakaļ")]), _vm._v(" "), _c('div', {
    staticClass: "or",
    attrs: {
      "data-text": "vai"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui custom_brown button",
    on: {
      "click": _vm.saveAddress
    }
  }, [_vm._v("Saglabāt")])]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "user-address-details-delete-dialog"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui custom_brown ok inverted button",
    on: {
      "click": _vm.deleteAddress
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Jā\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Pirms dzēsiet šo adresi, sākumā izvēlieties citu juridisko adresi!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("\n      Vai dzēst ierakstu?\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grey basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        Nē\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6155b583!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAddressEditPage.vue
// module id = 350
// module chunks = 1